class LanguageDropdown {
    constructor(selector) {
        this.dropdown = document.querySelector(selector);
        this.button = this.dropdown.querySelector('.language-selector__button');
        this.menu = this.dropdown.querySelector('.language-selector__menu');
  
        this.init();
    }
  
    init() {
        this.button.addEventListener('click', (event) => this.toggleMenu(event));
        document.addEventListener('click', (event) => this.handleDocumentClick(event));
  
        this.dropdown.addEventListener('mouseenter', this.openMenu.bind(this));
        this.dropdown.addEventListener('mouseleave', this.closeMenu.bind(this));
    }
  
    toggleMenu(event) {
        event.stopPropagation();

        const isExpanded = this.button.getAttribute("aria-expanded") === "true";
  
        this.button.setAttribute("aria-expanded", isExpanded);
        if (!isExpanded) {
            this.menu.classList.toggle('show');
        }
    }
  
    openMenu() {
        if (this.button.getAttribute("aria-expanded") === "false") {
            this.button.setAttribute("aria-expanded", "true");
            this.menu.classList.add('show');
        }
    }
  
    closeMenu() {
        if (this.button.getAttribute("aria-expanded") === "true") {
            this.button.setAttribute("aria-expanded", "false");
            this.menu.classList.remove('show');
        }
    }
  
    handleDocumentClick(event) {
        if (!this.dropdown.contains(event.target) && !this.button.contains(event.target)) {
            this.closeMenu();
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new LanguageDropdown('.site-header .language-selector');
});
